import { Location } from '@angular/common';
import { Injectable, OnDestroy } from '@angular/core';
import { Meta } from '@df/core/meta/meta';
import { Logger } from '@df/core/service/logger';
import { FacetUrlService } from '@df/module-facet-url/core/facet-url.service';
import { GTMServiceTrackContentViewEvent, GtmServiceViewItemListEvent } from '@df/module-gtm/gtm.service';
import { TimeoutService } from '@df/ng/timeout.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { GtmServiceDecorator } from '../../gtm/gtm.service.decorator';

/**
 * Plugin for meta data
 */
@Injectable({
    providedIn: 'root'
})
export class FacetUrlGtmPluginService implements OnDestroy {
    protected subscriptions = new Subscription();

    constructor(
        protected logger: Logger,
        protected meta: Meta,
        protected location: Location,
        protected gtmService: GtmServiceDecorator,
        protected facetUrlService: FacetUrlService,
        protected timeoutService: TimeoutService
    ) {
        this.patchMetaState();
        this.setContentViewTracking();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    protected patchMetaState() {
        this.subscriptions.add(
            this.gtmService.events.subscribe(event => {
                if (
                    (event.eventData.event === this.gtmService.eventsMap.viewItemList && event instanceof GtmServiceViewItemListEvent) ||
                    (event.eventData.event === this.gtmService.eventsMap.contentView && event instanceof GTMServiceTrackContentViewEvent)
                ) {
                    const facetData = this.facetUrlService.retrieveFacetData(Number(this.meta.model?.id));

                    if (facetData) {
                        if (!event.eventData['content-data']) {
                            event.eventData['content-data'] = {};
                        }

                        event.eventData['content-data'].facets = facetData.id;
                    } else {
                        delete event.eventData['content-data']?.facets;
                    }
                }
            })
        );
    }

    protected setContentViewTracking(): void {
        const onMetaChange = this.timeoutService.debounce(() => {
            try {
                const path = this.meta.getMetaProperty('url') || this.location.path();
                const facetData = this.facetUrlService.retrieveFacetData(Number(this.meta.model?.id));

                if (facetData) {
                    this.gtmService.publicTrackContentView(path, this.meta.model, this.meta.state?.metaData || undefined);
                }
            } catch (err) {
                this.logger.error(err);
            }
        }, 100);

        // meta subscription for content view events
        this.subscriptions.add(this.meta.subscribe(onMetaChange));
    }
}
